import {
  PriceIdEnum,
  ProductUnitsEnum,
  TerpeneEnumValues,
} from '@iheartjane/types';
import { z } from 'zod';

/**
 * Local copies of small schemas previously imported from `@jane/shared/types`.
 * Kept local so `@jane/shared/types` can be pure TypeScript (no Zod).
 * These are used to compose `AlgoliaProductSchema`, which validates
 * external Algolia search responses at runtime.
 */

const zId = z.coerce.number();

export const zBrandSpecialUserSegmentIds = z
  .union([z.literal(-1), z.array(z.number())])
  .nullish();

export const zProductUnitsEnum = z.enum(ProductUnitsEnum);

export const zTerpeneEnum = z.enum(TerpeneEnumValues);

export const zFlavor = z.object({
  id: zId,
  title: z.string(),
  value: z.string(),
});

const zPriceId = z.enum(PriceIdEnum);

export const zLabResult = z.object({
  price_id: zPriceId,
  lab_results: z.array(
    z.object({
      compound_name: z.string(),
      value: z.number(),
      unit: z.string(),
      unit_id: z.string(),
    })
  ),
});

export const zInventoryPotency = z.object({
  cbd_potency: z.number().nullable(),
  price_id: zPriceId.nullable(),
  tac_potency: z.number().nullable(),
  thc_potency: z.number().nullable(),
  thca_potency: z.number().nullable(),
});

export const zProductWeightSpecial = z.object({
  discount_amount: z.coerce.string().nullish(),
  discount_percent: z.string().nullish(),
  discount_price: z.string().nullish(),
  discount_type: z.string().nullish(),
  price: z.coerce.number().optional(),
  special_id: z.number().optional(),
  special_custom_badge: z.string().nullish(),
});
